import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_PACKAGE_PRICE } from "../../../Schema/PackagePrice";

const useDeletePackagePrice = ({ handleClose, setRefetch, id }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deletePackagePrice] = useMutation(DELETE_PACKAGE_PRICE, {
    onCompleted: ({ deletePackagePrice }) => {
      setLoading(false);
      if (deletePackagePrice?.isSuccess === true) {
        setAlert(true, "success", deletePackagePrice?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deletePackagePrice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deletePackagePrice({
      variables: {
        id: id,
      },
    });
  };

  return { deletePackagePrice, loading, setLoading, handleDelete };
};

export default useDeletePackagePrice;
